"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolygonMask = void 0;

var Type_1 = require("../../Enums/Type");

var Draw_1 = require("./Draw");

var Move_1 = require("./Move");

var Inline_1 = require("./Inline");

var LocalSvg_1 = require("./LocalSvg");

var PolygonMask = function () {
  function PolygonMask() {
    this.draw = new Draw_1.Draw();
    this.enable = false;
    this.inline = new Inline_1.Inline();
    this.move = new Move_1.Move();
    this.scale = 1;
    this.type = Type_1.Type.none;
  }

  Object.defineProperty(PolygonMask.prototype, "inlineArrangement", {
    get: function get() {
      return this.inline.arrangement;
    },
    set: function set(value) {
      this.inline.arrangement = value;
    },
    enumerable: false,
    configurable: true
  });

  PolygonMask.prototype.load = function (data) {
    var _a;

    if (data !== undefined) {
      this.draw.load(data.draw);
      var inline = (_a = data.inline) !== null && _a !== void 0 ? _a : {
        arrangement: data.inlineArrangement
      };

      if (inline !== undefined) {
        this.inline.load(inline);
      }

      this.move.load(data.move);

      if (data.scale !== undefined) {
        this.scale = data.scale;
      }

      if (data.type !== undefined) {
        this.type = data.type;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      } else {
        this.enable = this.type !== Type_1.Type.none;
      }

      if (data.url !== undefined) {
        this.url = data.url;
      }

      if (data.data !== undefined) {
        if (typeof data.data === "string") {
          this.data = data.data;
        } else {
          this.data = new LocalSvg_1.LocalSvg();
          this.data.load(data.data);
        }
      }

      if (data.position !== undefined) {
        this.position = {
          x: data.position.x,
          y: data.position.y
        };
      }
    }
  };

  return PolygonMask;
}();

exports.PolygonMask = PolygonMask;